import L from "leaflet";
import { useCallback, useEffect, useState } from "react";
import ProductsAPI from "../services/ProductsAPI";
import { useMap } from "./hooks/MapContext";
import { PlacesContext } from "./hooks/PlacesContext";

const PlacesProvider = PlacesContext.Provider;

export default function PlacesContainer({ children }) {
  const [places, setPlaces] = useState(null);
  const map = useMap();
  const [layer, setLayer] = useState(null);

  const fetchPlaces = useCallback(() => {
    if (!map) {
      return;
    }
    const currentBbox = map.getBounds().toBBoxString();
    ProductsAPI.getPlacesByBBox(currentBbox).then((data) => setPlaces(data));
  }, [map]);

  const removePlaces = useCallback(() => {
    setPlaces(null);
  }, []);

  useEffect(() => {
    if (places) {
      setLayer((currentLayer) => {
        if (currentLayer) {
          currentLayer.remove();
        }

        return L.geoJSON(places, {
          pointToLayer: (feature, latlng) => {
            return L.marker(latlng, {
              icon: L.icon.glyph({
                prefix: "material-icons",
                glyph: "place",
                glyphColor: "white",
                // Fix Retina bug by providing iconRetinaUrl
                iconRetinaUrl: L.Icon.Glyph.prototype.options.iconUrl,
              }),
            }).bindTooltip(feature.properties.name || "Local", {
              direction: "top",
              offset: [0, -30],
            }).bindPopup(`
              <div style="font-family: sans-serif; min-width: 150px;">
                <h3 style="margin: 0 0 5px 0; font-size: 14px; color: #333;">${feature.properties.name || "Local"}</h3>
                <p style="margin: 0 0 8px 0; font-size: 12px; color: #666; line-height: 1.4;">${feature.properties.address_line2 || ""}</p>
                
                <div style="margin: 8px 0; font-size: 11px; color: #444;">
                  ${feature.properties.phone ? `<div style="margin-bottom: 3px;"><strong>Tel:</strong> ${feature.properties.phone}</div>` : ""}
                  ${feature.properties.email ? `<div style="margin-bottom: 3px;"><strong>Email:</strong> <a href="mailto:${feature.properties.email}">${feature.properties.email}</a></div>` : ""}
                  ${feature.properties.website ? `<div style="margin-bottom: 3px;"><strong>Site:</strong> <a href="${feature.properties.website}" target="_blank" rel="noopener noreferrer">Visitar website</a></div>` : ""}
                </div>
              </div>
            `);
          },
        });
      });
    } else {
      setLayer((currentLayer) => {
        if (currentLayer) {
          currentLayer.remove();
        }

        return null;
      });
    }
  }, [places]);

  useEffect(() => {
    if (layer) {
      map.addLayer(layer);
    }
  }, [layer, map]);

  return (
    <PlacesProvider value={places}>
      <div
        style={{
          width: "inherit",
          height: "inherit",
          pointerEvents: "all",
        }}
      >
        <div
          style={{
            position: "fixed",
            width: 32,
            height: 32,
            marginLeft: 10,
            marginTop: 330,
            zIndex: 1001,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-around",
            backgroundColor: "#ffffff",
          }}
        >
          <button
            style={{
              width: 32,
              height: 32,
              padding: 0,
              border: "solid 2px #00000033",
              pointerEvents: "auto",
              cursor: "pointer",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            onClick={places ? removePlaces : fetchPlaces}
          >
            <img
              style={{
                width: 28,
                height: 28,
              }}
              src={
                places ? `images/remove_places.jpg` : `images/search_places.png`
              }
              alt={places ? "Remover locais" : "Buscar locais"}
            />
          </button>
        </div>
        {children}
      </div>
    </PlacesProvider>
  );
}
